import { useState, useEffect } from "react";

const SEARCH_HISTORY_KEY = "search_history";
const MAX_HISTORY_ITEMS = 10;

const useSearchHistory = () => {
  const [searchHistory, setSearchHistory] = useState([]);

  // Load history from localStorage on mount
  useEffect(() => {
    const savedHistory = localStorage.getItem(SEARCH_HISTORY_KEY);
    if (savedHistory) {
      setSearchHistory(JSON.parse(savedHistory));
    }
  }, []);

  // Save history to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(searchHistory));
  }, [searchHistory]);

  const addToHistory = (query) => {
    if (!query.trim()) return;

    setSearchHistory((prev) => {
      const filtered = prev.filter((item) => item.query !== query);
      return [
        { query, timestamp: new Date().toISOString() },
        ...filtered,
      ].slice(0, MAX_HISTORY_ITEMS);
    });
  };

  const removeFromHistory = (query) => {
    setSearchHistory((prev) => prev.filter((item) => item.query !== query));
  };

  const clearHistory = () => {
    setSearchHistory([]);
  };

  return {
    searchHistory,
    addToHistory,
    removeFromHistory,
    clearHistory,
  };
};

export default useSearchHistory;
